import { useEffect, useState } from "react";
import Card, { SectionTitle } from "@/components/base/Card";
import Button from "@/components/base/Button";
import Toggle from "@/components/base/Toggle";
import { useToast } from "@/components/base/Toast";
import {
  getNotificationPreferences,
  updateNotificationPreferences,
  type NotificationPreference,
} from "@/services/notificationService";

/** Choix des alertes affichées dans la cloche de l'en-tête (seulement celles permises par le rôle). */
export default function NotificationPreferencesCard() {
  const { notify } = useToast();
  const [prefs, setPrefs] = useState<NotificationPreference[] | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getNotificationPreferences()
      .then(setPrefs)
      .catch(() => setPrefs([]));
  }, []);

  if (prefs !== null && prefs.length === 0) return null;

  const save = async () => {
    if (!prefs) return;
    setSaving(true);
    try {
      setPrefs(await updateNotificationPreferences(prefs.filter((p) => p.muted).map((p) => p.type)));
      notify("Préférences d'alertes enregistrées.");
    } catch (err) {
      notify(err instanceof Error ? err.message : "Enregistrement impossible.", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <SectionTitle
        icon="ri-notification-3-line"
        title="Alertes"
        subtitle="Choisissez ce qui s'affiche dans la cloche, en haut de l'écran"
      />
      {prefs === null ? (
        <p className="text-sm text-foreground-500">Chargement...</p>
      ) : (
        <div className="space-y-3">
          {prefs.map((p) => (
            <Toggle
              key={p.type}
              label={p.label}
              description={p.description}
              value={!p.muted}
              onChange={(on) => setPrefs(prefs.map((x) => (x.type === p.type ? { ...x, muted: !on } : x)))}
            />
          ))}
        </div>
      )}
      <div className="mt-5 flex justify-end">
        <Button icon="ri-save-3-line" onClick={save} disabled={saving || prefs === null}>
          {saving ? "Enregistrement..." : "Enregistrer"}
        </Button>
      </div>
    </Card>
  );
}
